import React from 'react';
import loadImage from 'blueimp-load-image';
import randomstring from 'uuid/v4';

import ProcessApi from '../../api/ProcessApi';

function getImageDimensions(file) {
    return new Promise(function(resolved, rejected) {
        var i = new Image();
        i.onload = function() {
            resolved(i);
        };
        i.src = file;
    });
}

async function generateThumbnail(src) {
    var img = await getImageDimensions(src);
    var oc = document.createElement('canvas'),
        octx = oc.getContext('2d');
    oc.width = img.width;
    oc.height = img.height;
    octx.drawImage(img, 0, 0);
    while (oc.width * 0.5 > 64) {
        oc.width *= 0.5;
        oc.height *= 0.5;
        octx.drawImage(oc, 0, 0, oc.width, oc.height);
    }
    oc.width = 64;
    oc.height = (oc.width * img.height) / img.width;
    octx.drawImage(img, 0, 0, oc.width, oc.height);
    return oc.toDataURL('image/jpeg');
}

function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}

class FileBase64 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    async handleChange(e) {
        this.props.onStart();

        // get the files
        let files = this.props.multiple ? [...e.target.files] : [e.target.files[0]];

        // Process each file
        var allFiles = [];
        for (const file of files) {
            const key = randomstring();
            await loadImage.parseMetaData(file, async (data) => {
                //default image orientation
                var orientation = 0;
                //if exif data available, update orientation
                if (data.exif) {
                    orientation = data.exif.get('Orientation');
                }
                console.log(data);
                var loadingImage = await loadImage(
                    file,
                    async (canvas) => {
                        //here's the base64 data result
                        var base64data = canvas.toDataURL('image/jpeg');

                        generateThumbnail(base64data).then(async (thumbnail) => {
                            let fileInfo = {
                                name: file.name,
                                type: file.type,
                                size: file.size,
                                link: dataURItoBlob(base64data),
                                comentario: '',
                                key: key,
                                thumbnail: dataURItoBlob(thumbnail),
                            };

                            const url = await ProcessApi.uploadImage(
                                this.props.instance,
                                this.props.field,
                                fileInfo,
                            )
                                .then((url) => {
                                    // Push it to the state
                                    allFiles.push({
                                        comentario: '',
                                        base: `${url}`,
                                        link: `${url}/datos`,
                                        thumbnail: `${url}/miniatura`,
                                    });

                                    // If all files have been proceed
                                    if (allFiles.length === files.length) {
                                        this.props.onDone(allFiles);
                                    }
                                    return url;
                                })
                                .catch((error) => {
                                    this.props.onError(error.message);
                                });
                            console.log(url);
                        });
                    },
                    {
                        //should be set to canvas : true to activate auto fix orientation
                        canvas: true,
                        orientation: orientation,
                    },
                );
                console.log(loadingImage);
            });
        } // for
    }

    render() {
        return (
            <input
                type="file"
                accept=".gif,.jpg,.jpeg,.png"
                onChange={this.handleChange.bind(this)}
                multiple={this.props.multiple}
            />
        );
    }
}

FileBase64.defaultProps = {
    multiple: false,
};

export default FileBase64;



// WEBPACK FOOTER //
// ./src/components/inputs/Paint.js